import styled from 'src/styles/theme';
import { ModalShareOfferSummaryStyled } from '../../ModalShareOfferSummaryStyled';

export const ModalShareOfferSummaryStyledOVGB = styled(ModalShareOfferSummaryStyled)`
    .wrapper > .form > .formRow > button {
        color: ${({ theme }) => theme.colors.white};
    }
`;
